export default {
  computed: {
    chatClient: {
      get() {
        return this.$store.state.meeting.chatClient
      },
      set(v) {
        this.$store.commit("meeting/setChatClient", v)
      }
    },
    chatConversation: {
      get() {
        return this.$store.state.meeting.chatConversation
      },
      set(v) {
        this.$store.commit("meeting/setChatConversation", v)
      }
    },
    chatMessages: {
      get() {
        return this.$store.state.meeting.chatMessages
      },
      set(v) {
        this.$store.commit("meeting/setChatMessages", v)
      }
    },
    chatUsers: {
      get() {
        return this.$store.state.meeting.chatUsers
      },
      set(v) {
        this.$store.commit("meeting/setChatUsers", v)
      }
    },
    visioRoom: {
      get() {
        return this.$store.state.meeting.visioRoom
      },
      set(v) {
        this.$store.commit("meeting/setVisioRoom", v)
      }
    },
    visioUsers: {
      get() {
        return this.$store.state.meeting.visioUsers
      },
      set(v) {
        this.$store.commit("meeting/setVisioUsers", v)
      }
    }
  }
}
